export default {
  text_1_1: 'Tutoriel',

  text_2_1: 'Tutoriel de sauvegarde',
  text_2_2: 'Tutoriel d’importation',
  text_2_3: 'Tutoriel avancé (fonction de paiement)',

  text_3_1: 'Créer un portefeuille',
  text_3_1_1: 'Après avoir sélectionné « Create Wallet », passez à la procédure de sauvegarde.',

  text_3_2: 'Sauvegarde',
  text_3_2_1:
    'Sur la page de sauvegarde, sélectionnez « Sauvegarde par KeyPal Card ». Le processus comporte 4 étapes : (1) définir un code PIN pour la carte ; (2) sauvegarder la phrase de récupération sur la carte ; (3) vérifier l’exactitude de la sauvegarde ; (4) commencer à l’utiliser.',
  text_3_2_2:
    'Touchez « Démarrer la sauvegarde ». Pour éviter les erreurs, vous devrez saisir deux fois votre PIN. Le PIN protège la sauvegarde et contrôle l’accès à la carte. Remarque : vous êtes responsable de la sécurité de votre PIN — mémorisez-le !',
  text_3_2_3:
    'Après avoir défini le PIN, placez la carte KeyPal sur l’appareil photo arrière (zone NFC) selon les instructions. Sur iOS, l’établissement d’une connexion sécurisée peut prendre quelques secondes — ce léger délai est normal.',
  text_3_2_4:
    'Une fois la détection terminée et les données vérifiées, votre phrase de récupération est chiffrée puis écrite sur la carte. L’interface confirme la fin de la sauvegarde.',
  text_3_2_5:
    'Après la sauvegarde, passez à l’étape finale — la vérification de sauvegarde. Nous la recommandons vivement !',

  text_3_3: 'Vérification',
  text_3_3_1:
    'Suivez le guide pour saisir le PIN défini pour votre carte, puis approchez la carte de l’appareil photo arrière pour la détection NFC.',
  text_3_3_2:
    'En cas de succès, un message s’affiche. Pour éviter toute fuite, la phrase mnémonique est partiellement masquée ; suivez les invites pour vérifier mot à mot.',
  text_3_3_3:
    'Après vérification, touchez « Suivant » pour commencer à l’utiliser. Pour plus de polyvalence et de sécurité, nous proposons aussi la « Fonction de paiement » — voir le « Tutoriel des fonctions avancées ».',

  text_3_4: 'Notes et précautions',
  text_3_4_1:
    '1. TokenPocket ne stocke pas votre PIN. Retenez-le et sauvegardez-le vous-même.',
  text_3_4_2:
    '2. Chaque carte peut avoir un PIN unique. Dix saisies erronées consécutives effacent intégralement les données de la carte.',
  text_3_4_3: '3. Il est recommandé d’utiliser une carte KeyPal neuve pour la sauvegarde.',
  text_3_4_4:
    '4. La réinitialisation de la carte supprime toutes les données de manière complète et irréversible. Assurez-vous de le comprendre.',
  text_3_4_5:
    '5. Sur iOS, la sauvegarde et l’utilisation peuvent être plus lentes — c’est normal. Merci de patienter.',

  text_4_1: 'Tutoriel d’importation',
  text_4_2_1:
    'Avec une KeyPal Card sauvegardée, vous pouvez importer les portefeuilles dans TokenPocket. L’importation prend en charge un seul réseau ou plusieurs réseaux ; nous détaillons ici l’import multi-réseaux (similaire au mode mono-réseau).',
  text_4_3_1:
    '1. Choisissez « Importer un portefeuille », touchez « Portefeuille matériel KeyPal », puis sélectionnez KeyPal Card dans la fenêtre.',
  text_4_3_2:
    '2. Après avoir choisi la carte, touchez « Démarrer l’import » et saisissez le PIN.',
  text_4_3_3:
    '3. Après le PIN, l’écran de scan s’affiche. Approchez la carte de l’appareil photo arrière, puis touchez « Démarrer le scan » pour lancer la lecture NFC. Sur iOS, cela peut prendre un peu de temps.',
  text_4_3_4:
    '4. Lorsque la phrase est lue avec succès, une notification s’affiche. Touchez « Suivant » pour choisir les réseaux et créer votre portefeuille. La « Fonction de paiement » est détaillée dans le « Tutoriel des fonctions avancées ».',

  text_4_4: 'Notes et précautions',
  text_4_4_1:
    '1. Sur iOS, la sauvegarde et l’utilisation peuvent être plus lentes — c’est normal.',
  text_4_4_2:
    '2. Avant la lecture, la saisie du PIN est obligatoire. En cas de 10 erreurs consécutives, la carte efface automatiquement toutes ses données ; une saisie correcte remet le compteur à zéro.',
  text_4_4_3:
    '3. Avec la « Fonction de paiement », la phrase de récupération n’est pas stockée sur le téléphone. Chaque transaction nécessite un scan de la carte pour la signature.',

  text_5_1: 'Tutoriel avancé',
  text_5_2_1:
    'La fonction de paiement améliore la polyvalence tout en gardant la phrase mnémonique et la clé privée hors ligne et plus sûres (non stockées sur le téléphone).',
  text_5_3_1:
    '1. À la création/import, utilisez les options avancées pour ne pas stocker la phrase/clé sur l’appareil. Les transactions seront signées en scannant la carte.',
  text_5_3_2:
    '2. Lors d’un transfert ou d’une transaction DApp, le panneau affiche « Scanner la carte pour payer ». Touchez pour démarrer le flux de paiement.',
  text_5_3_3:
    '3. Touchez ensuite pour saisir le PIN de votre carte et vérifier votre identité.',
  text_5_3_4:
    '4. Placez la carte selon les instructions pour la lecture et la signature. Après la signature, la transaction est envoyée sur la blockchain.',

  text_5_4: 'Notes et précautions',
  text_5_4_1:
    '1. Avant la lecture, saisissez le PIN. Après 10 erreurs consécutives, toutes les données sont effacées ; une saisie correcte réinitialise le compteur.',
  text_5_4_2:
    '2. Avec la « Fonction de paiement », la phrase n’est jamais stockée sur le téléphone : chaque opération requiert le scan de la carte pour signer.',
};
